<template>
  <proctoring-gate :inner="testComponent" />
</template>

<script>
import ProctoringGate from "../../components/ProctoringGate.vue";
import Test from "./Test.vue";

export default {
  name: "ProctoredTest",
  components: { ProctoringGate },
  computed: {
    // Через computed, а не data — чтобы Vue не делал определение компонента реактивным.
    testComponent() {
      return Test;
    },
  },
};
</script>
